import { apiClient } from "./apiClient";

import type {
  CreateDashboardUserInput,
  DashboardUserDetailsData,
  DashboardUserPasswordResetLinkData,
  DashboardUserPasswordUpdatedData,
  DashboardUserSessionsRevokedData,
  DashboardUsersListData,
  DashboardUsersQuery,
  DashboardUsersStatsData,
  UpdateDashboardUserInput,
} from "../types/dashboard-users.types";

function buildQuery(
  query: DashboardUsersQuery = {},
): string {
  const params =
    new URLSearchParams();

  if (query.search?.trim()) {
    params.set(
      "search",
      query.search.trim(),
    );
  }

  if (query.roleId?.trim()) {
    params.set(
      "roleId",
      query.roleId.trim(),
    );
  }

  if (
    query.isActive !==
    undefined
  ) {
    params.set(
      "isActive",
      String(
        query.isActive,
      ),
    );
  }

  if (
    query.isSuperAdmin !==
    undefined
  ) {
    params.set(
      "isSuperAdmin",
      String(
        query.isSuperAdmin,
      ),
    );
  }

  if (query.sort) {
    params.set(
      "sort",
      query.sort,
    );
  }

  if (
    query.limit !==
    undefined
  ) {
    params.set(
      "limit",
      String(
        query.limit,
      ),
    );
  }

  if (query.cursor?.trim()) {
    params.set(
      "cursor",
      query.cursor.trim(),
    );
  }

  const queryString =
    params.toString();

  return queryString
    ? `?${queryString}`
    : "";
}

export const dashboardUsersApi = {
list(
  query:
    DashboardUsersQuery = {},
) {
  return apiClient.get<
    DashboardUsersListData
  >(
    `/dashboard-users${buildQuery(
      query,
    )}`,
  );
},

stats() {
  return apiClient.get<
    DashboardUsersStatsData
  >(
    "/dashboard-users/stats",
  );
},

 getById(
  uid: string,
) {
  return apiClient.get<
    DashboardUserDetailsData
  >(
    `/dashboard-users/${encodeURIComponent(
      uid,
    )}`,
  );
},

 create(
  input:
    CreateDashboardUserInput,
) {
  return apiClient.post<
    DashboardUserDetailsData
  >(
    "/dashboard-users",
    input,
  );
},

 update(
  uid: string,
  input:
    UpdateDashboardUserInput,
) {
  return apiClient.patch<
    DashboardUserDetailsData
  >(
    `/dashboard-users/${encodeURIComponent(
      uid,
    )}`,
    input,
  );
},

 updateStatus(
  uid: string,
  isActive: boolean,
) {
  return apiClient.patch<
    DashboardUserDetailsData
  >(
    `/dashboard-users/${encodeURIComponent(
      uid,
    )}/status`,
    {
      isActive,
    },
  );
},

updateRole(
  uid: string,
  roleId: string | null,
) {
  return apiClient.patch<
    DashboardUserDetailsData
  >(
    `/dashboard-users/${encodeURIComponent(
      uid,
    )}/role`,
    {
      roleId,
    },
  );
},

updatePermissions(
  uid: string,
  permissionIds: string[],
) {
  return apiClient.patch<
    DashboardUserDetailsData
  >(
    `/dashboard-users/${encodeURIComponent(
      uid,
    )}/permissions`,
    {
      permissionIds,
    },
  );
},

updateSuperAdmin(
  uid: string,
  isSuperAdmin: boolean,
) {
  return apiClient.patch<
    DashboardUserDetailsData
  >(
    `/dashboard-users/${encodeURIComponent(
      uid,
    )}/super-admin`,
    {
      isSuperAdmin,
    },
  );
},

 

  
setPassword(
  uid: string,
  password: string,
) {
  return apiClient.patch<
    DashboardUserPasswordUpdatedData
  >(
    `/dashboard-users/${encodeURIComponent(
      uid,
    )}/password`,
    {
      password,
    },
  );
},

createPasswordResetLink(
  uid: string,
) {
  return apiClient.post<
    DashboardUserPasswordResetLinkData
  >(
    `/dashboard-users/${encodeURIComponent(
      uid,
    )}/password-reset-link`,
    {},
  );
},

revokeSessions(
  uid: string,
) {
  return apiClient.post<
    DashboardUserSessionsRevokedData
  >(
    `/dashboard-users/${encodeURIComponent(
      uid,
    )}/revoke-sessions`,
    {},
  );
},

  delete(
    uid: string,
  ) {
    return apiClient.delete(
      `/dashboard-users/${encodeURIComponent(
        uid,
      )}`,
    );
  },
};

